
import BurnabyHero from './components/BurnabyHero';
import BurnabyOverview from './components/BurnabyOverview';
import BurnabyLicensing from './components/BurnabyLicensing';
import BurnabyZoning from './components/BurnabyZoning';
import BurnabyMarket from './components/BurnabyMarket';
import BurnabyCTA from './components/BurnabyCTA';
import { Navbar } from '../home/components/Navbar';
import { Footer } from '../home/components/Footer';

export default function BurnabySTR() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <BurnabyHero />
        <BurnabyOverview />
        <BurnabyLicensing />
        <BurnabyZoning />
        <BurnabyMarket />
        <BurnabyCTA />
      </main>
      <Footer />
    </div>
  );
}
